module.exports = __webpack_public_path__ + "img/live-video.8b59c6cd.svg";